export default "<h1>FA Solid 实体图标</h1>\n<p>来自 FontAwesome 的图标库.</p>\n"